import { INDENTIFY_DONOR_DATA, KPI_DATA, RECENT_DONOR_COLLECTION_COUNT, RECENT_DONOR_COLLECTION_COUNT_LOAD, RECENT_DONOR_COLLECTION_DATA, RECENT_DONOR_COLLECTION_LOAD, RECENT_DONOR_INF_DATA, RECENT_DONOR_SCREENING_DATA, RECENT_DONOR_SCREENING_DATA_LIST, RECENT_DONOR_SCREENING_DATA_SCREEN, RECENT_DONOR_SCREENING_DATA_SCREEN_TEST } from "../../actions/medicalTemplate"

const initState = {
  dataKpi: null,
}

export const kpiDataReducer = (state = initState, action = {}) => {
  switch (action.type) {
    case KPI_DATA:
      return { ...state, ...action }
    default:
      return state
  }
}


const initStates = {
  identifyDonorData: null,
}
export const indenTifyProcessDataReducer = (state = initStates, action = {}) => {
  switch (action.type) {
    case INDENTIFY_DONOR_DATA:
      return { ...state, ...action }
    default:
      return state
  }
}


const initStatess = {
  donorINFData: null,
}
export const donorINFReducer = (state = initStatess, action = {}) => {
  switch (action.type) {
    case RECENT_DONOR_INF_DATA:
      return { ...state, ...action }
    default:
      return state
  }
}

const initStatesss = {
  dataList: null,
  ScreeningData: null,
  screeningTestData: null,
}
export const donorScreeningReducer = (state = initStatesss, action = {}) => {
  switch (action.type) {
    case RECENT_DONOR_SCREENING_DATA:
      return { ...state, ...action }
    case RECENT_DONOR_SCREENING_DATA_LIST:
      return { 
        ...state,
        dataList: action.payload }
    case RECENT_DONOR_SCREENING_DATA_SCREEN:
      return { 
        ...state,
        ScreeningData: action.payload }
    case RECENT_DONOR_SCREENING_DATA_SCREEN_TEST:
      return { 
        ...state,
        screeningTestData: action.payload }
    default:
      return state
  }
}

const initStatessss = {
  collectionInfmation: null,
}
export const donoCollectionReducer = (state = initStatessss, action = {}) => {
  switch (action.type) {
    case RECENT_DONOR_COLLECTION_DATA:
      return { ...state, ...action }
    default:
      return state
  }
}

const initStatesssss = {
  countLR: null,
  countLRLoad: true,
}
export const donoCollectionCountReducer = (state = initStatesssss, action = {}) => {
  switch (action.type) {
    case RECENT_DONOR_COLLECTION_COUNT:
      return { ...state, ...action }
    case RECENT_DONOR_COLLECTION_COUNT_LOAD:
      return {
        ...state,
        countLRLoad: action.payload
      }
    default:
      return state
  }
}


const initStatessLoad = {
  collectionLoad: false,
}
export const donoCollectionLoadReducer = (state = initStatessLoad, action = {}) => {
  switch (action.type) {
    case RECENT_DONOR_COLLECTION_LOAD:
      return { ...state, ...action }
    default:
      return state
  }
}
